// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__LuHAX","footer":"ModalUpdate_footer__186_m"};